import { Navigate, useParams } from 'react-router-dom';

export default function CommunitySponsorDetail() {
  const { handle = '' } = useParams();
  if (!handle) return <Navigate to="/sponsor" replace />;
  return <Navigate to={`/s/${encodeURIComponent(handle)}`} replace />;
}
